import styled from "styled-components";

const FormElementDivider = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
`;

export default FormElementDivider;
